import moment from 'moment';
import { useEffect, useState } from 'react';
import { IconBase } from 'react-icons';
import { MdOutlineCopyAll } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import Container from '~/components/container';
import Loading from '~/components/loading';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';
import * as St from './styles';
import { icons } from '~/assets';
import Dialog from '~/components/dialog';
import Popover from '~/components/Popover';
import ContainerFlex from '~/components/containerFlex';
import HeaderConference from '../../AntecipationPurchase/components/headerConference';
import ConferencePaymentOptions from '../../AntecipationPurchase/components/paymentOptions';
import ListConference from '../../AntecipationPurchase/components/listConference';

interface IGeneratePixResponse {
  base64?: string;
  emv?: string;
  txid?: string;
}

const AntecipationInvoiceChoosePayment: React.FC = () => {
  const history = useHistory<any>();
  const locationState = history.location.state;

  const { dataFinancial } = locationState.locationState;

  const [valorTotal, setValorTotal] = useState('');
  const [dialog, setDialog] = useState({
    open: false,
    error: false,
    pix: false,
  });
  const [dialogMessage, setDialogMessage] = useState('');
  const [data, setData] = useState(null);
  const [codePix, setCodePix] = useState<IGeneratePixResponse>(
    [] as IGeneratePixResponse,
  );
  const [descontoTotal, setDescontoTotal] = useState('');

  const RequestCreateAntecipationCaixa = useApi(
    Endpoints.invoices.postAntecipationArray,
    ApiMethod.POST,
  );

  const RequestCreateAntecipationPix = useApi(
    Endpoints.invoices.postAntecipationArray,
    ApiMethod.POST,
  );

  const RequestChargePixGenerate = useApi<IGeneratePixResponse>(
    Endpoints.invoices.postChargePixGenerate,
    ApiMethod.POST,
  );

  useEffect(() => {
    const value = [];
    dataFinancial?.map((dataP) => {
      if (dataP.parcelasAAntecipar > 0) {
        value.push(dataP);
      }
      return dataP;
    });
    setData(value);
  }, []);

  useEffect(() => {
      async function populaValor() {
        let aux = 0;
        let auxDesconto = 0;
        if (data) {
          setValorTotal('');
          setDescontoTotal('');
          data.map((item) => {
            aux = item.valorAntecipacao + aux;
          });
          data.map((item) => {
            auxDesconto = item.valorDesconto + auxDesconto;
          })
          setValorTotal(String(aux));
          setDescontoTotal(String(auxDesconto));
        }
      }
  
      populaValor();
    }, [data]);

  const requestFinancialParcelCaixa = async (payload) => {
    try {
      const response: any = await RequestCreateAntecipationCaixa.callApi(
        payload,
      );

      if (response.status >= 200 && response.status < 300) {
        setDialog({ open: true, error: false, pix: false });
        setDialogMessage('Solicitação enviada com sucesso!');
      } else {
        setDialog({ open: true, error: true, pix: false });
        setDialogMessage(
          response.data?.mensagem || 'Tivemos um erro, Tente novamente!',
        );
      }
    } catch (err) {
      setDialog({ open: true, error: true, pix: false });
      setDialogMessage('Tivemos um erro, Tente novamente!');
    }
  };

  const requestFinancialParcelPix = async (payload) => {
    try {
      const response: any = await RequestCreateAntecipationPix.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        setDialog({ open: true, error: false, pix: true });
        setDialogMessage('Solicitação enviada com sucesso!');
      } else {
        setDialog({ open: true, error: true, pix: true });
        setDialogMessage(
          response.data?.mensagem || 'Tivemos um erro, Tente novamente!',
        );
      }
    } catch (err) {
      setDialog({ open: true, error: true, pix: true });
      setDialogMessage('Tivemos um erro, Tente novamente!');
    }
  };

  const handleSubmit = async (paymentOption: 'PIX' | 'CAIXA') => {
    if (paymentOption === 'PIX') {
      const payload =
        data.length > 0
          ? {
              cpf: data[0]?.cpf,
              valor: Number(valorTotal),
            }
          : null;

      try {
        const response = await RequestChargePixGenerate.callApi(payload);

        if (response.status >= 200 && response.status < 300) {
          setCodePix(response.data);

          const { emv, base64, txid } = response.data;

          const payloadAntecipation = [];

          data.map((dataP) => {
            payloadAntecipation.push({
              cartao: dataP?.cartao,
              cpf: dataP?.cpf,
              dataFechamento: String(
                moment(dataP?.dataCorte).format('YYYY-MM-DD'),
              ),
              email: dataP?.email,
              idParcelamento: dataP.idFinanciamento,
              nomeCliente: dataP?.nomeCompleto,
              parcelasAntecipadas: dataP?.parcelasAAntecipar,
              valorAntecipacao: dataP?.valorAntecipacao,
              tipoAntecipacao: 'FINANCIAMENTO',
              origemAntecipacao: 'CENTRAL',
              qrcodeBase64: base64,
              txId: txid,
              pixCopiaECola: emv,
            });
          });

          await requestFinancialParcelPix(payloadAntecipation);
        }

        if (response.status >= 400) {
          setDialog({ open: true, error: true, pix: false });
          setDialogMessage(
            response.mensagem ? response.mensagem : 'Serviço indisponível',
          );
        }
      } catch (error) {
        console.log(error);
      }
    } else if (paymentOption === 'CAIXA') {
      const payload = [];

      data.map((dataP) => {
        payload.push({
          cartao: dataP?.cartao,
          cpf: dataP?.cpf,
          dataFechamento: String(moment(dataP?.dataCorte).format('YYYY-MM-DD')),
          email: dataP?.email,
          idParcelamento: dataP.idFinanciamento,
          nomeCliente: dataP?.nomeCompleto,
          parcelasAntecipadas: dataP?.parcelasAAntecipar,
          valorAntecipacao: dataP?.valorAntecipacao,
          tipoAntecipacao: 'FINANCIAMENTO',
          origemAntecipacao: 'CENTRAL',
        });
      });

      await requestFinancialParcelCaixa(payload);
    }
  };

  const [popoverPixIsOpen, setPopoverPixIsOpen] = useState(false);

  return (
    <Container>
      <Loading
        status={
          RequestCreateAntecipationPix.loading ||
          RequestCreateAntecipationCaixa.loading ||
          RequestChargePixGenerate.loading
        }
      />
      <Dialog
        icon={dialog?.error ? icons.exclamation : icons.check}
        open={dialog?.open}
        title={
          dialog?.error
            ? 'Houve um erro, tente novamente'
            : 'Solicitação concluida com sucesso!'
        }
        positiveLabel="Entendi"
        widthInPercent={30}
        positiveAction={() => {
          if (!dialog.error) {
            history.push('/invoice/antecipation');
          }
          setDialog({ open: false, error: false, pix: false });
        }}
        message={dialogMessage}
      >
        {dialog?.pix ? (
          <ContainerFlex gap="14">
            <ContainerFlex row center gap="8">
              <St.Title style={{ fontWeight: 700, fontSize: '24px' }}>
                Pix copia e cola:
              </St.Title>
              <IconBase
                size={24}
                fontSize={24}
                style={{ cursor: 'pointer' }}
                onClick={async () => {
                  await navigator.clipboard.writeText(codePix?.emv);
                  setPopoverPixIsOpen(true);
                  setTimeout(() => setPopoverPixIsOpen(false), 3000);
                }}
              >
                <MdOutlineCopyAll />
              </IconBase>
            </ContainerFlex>

            <St.Info>
              {codePix.emv}
            </St.Info>
          </ContainerFlex>
        ) : null}
      </Dialog>
      <div
        style={{
          position: 'absolute',
          zIndex: 999,
          right: '17px',
          top: '2rem',
        }}
      >
        <Popover open={popoverPixIsOpen}>
          <ContainerFlex row center gap="8">
            <img width={16} height={16} src={icons.check} alt="check" />
            <p>Código copiado com sucesso!</p>
          </ContainerFlex>
        </Popover>
      </div>
      {data?.length > 0 ? (
        <>
           <HeaderConference
            nomeCompleto={data[0]?.nomeCompleto}
            cpf={data[0]?.cpf}
            numeroCartao={data[0]?.cartao}
            valorTotal={Number(valorTotal)}
            data={dataFinancial}
            financial
            descontoTotal={Number(descontoTotal)}
          />
          <ConferencePaymentOptions onSubmit={handleSubmit} />
          <ContainerFlex row marginBottom={20}>
            <St.DescriptionInfo>
              Comunique o cliente que deverá pagar o quanto antes, pois a
              antecipação tem prazo de validade para o mesmo dia e depois é
              cancelada!
            </St.DescriptionInfo>
          </ContainerFlex>
          <St.BoxCard>
            <ListConference data={data} typeList="FINANCIAL"/>
          </St.BoxCard>
        </>
      ) : null}
    </Container>
  );
};

export default AntecipationInvoiceChoosePayment;
